<bari-header *ngIf="showHeader"></bari-header>

<div id="inner">
  <router-outlet></router-outlet>
</div>

<bari-footer></bari-footer>
